// @flow
// datepicker
import { Datepicker } from 'fg-frontend/src/components/Datepicker';
//import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/l10n/cs';
import 'flatpickr/dist/l10n/sk';

import {RangeSlider} from "fg-frontend/src/components/RangeSlider";

import configureEshopComponents from './configureEshopComponents';

export default (props) => {
	switch (props.decorator || props.is) {
		case 'AddSvgIconSprite':
			return import('./components/AddSvgIconSprite');
		case 'WebLayout':
			return import('./components/WebLayout');
		case 'RadioSelect':
			return import('fg-frontend/src/components/RadioSelect');
		case 'CheckboxSelect':
			return import('fg-frontend/src/components/CheckboxSelect');
		case 'SimpleCollapse':
			return import('./components/SimpleCollapse');
		case 'SizeGuide':
			return import('./components/SizeGuide');
		case 'SubmenuToggle':
			return import('./components/SubmenuToggle');
		case 'GalleryWebslider':
			return import('./components/GalleryWebslider');
		case 'Typeahead':
			return import('fg-frontend/components/Typeahead');
		case 'SelectDesign':
			return import('./components/SelectDesign');
		case 'ListToggle':
			return import('fg-frontend/components/ListToggle');
		case 'PasswordToggle':
			return import('fg-frontend/components/PasswordToggle');
		case 'SocialShare':
			return import('fg-frontend/components/SocialShare');
		case 'AnchorsList':
			return import('fg-frontend/src/components/AnchorsList');
		/*case 'Slider':
			return Slider;*/
		case 'RadioSelectTab':
			return import('fg-frontend/src/components/RadioSelectTab');
		case 'NumberInput':
			return import('fg-frontend/components/NumberInput');
		case 'UniversalPaginationButton':
			return import('fg-frontend/components/UniversalPaginationButton');
		case 'Tooltip':
			return import('./components/Tooltip');
		case 'GtmHandler':
			return import('./components/GtmHandler');
		case 'TriggerInViewport':
			return import('./components/TriggerInViewport');
		case 'ShareUrl':
			return import('fg-frontend/src/components/ShareUrl');
		case 'PhotoSwipe':
			return import('./components/PhotoSwipe');
		case 'RedirectToUrl':
		  return import('fg-frontend/src/components/RedirectToUrl');
		case 'Form':
		  return import('fg-frontend/src/components/Form');
		case 'LazyImage':
		  return import('./components/LazyImage');
		case 'Webslider':
		  return import('fg-frontend/src/components/Webslider');
		case 'PrintPage':
		  return import('fg-frontend/src/components/PrintPage');
		case 'PrintPdf':
			return import('fg-frontend/src/components/PrintPdf');
		case 'FileInput':
		  return import('fg-frontend/src/components/FileInput');
		case 'RangeDatepicker':
			return import('fg-frontend/components/RangeDatepicker');
		case 'RangeSlider':
			return RangeSlider;
		case 'GoogleMap':
            return import('./components/GoogleMap');
		case 'GoogleRecaptcha':
			// COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
			return import('fg-frontend/src/components/GoogleRecaptcha');
		case 'Datepicker':
			return Datepicker;
    case 'FGUpload':
      // COMMON: Komponenta pro multi upload souboru (odeberte, pokud nepouzivate RJ fileUpload komponentu)
      return import('./components/FGUpload');
    case 'PreventDoubleClickHandler':
      // COMMON: Komponenta zajistuje deaktivaci odkazu po prvnim kliknuti
      return import('fg-frontend/src/components/PreventDoubleClickHandler');
		default:
			const eshopComponent = configureEshopComponents(props);
			if (eshopComponent) {
				return eshopComponent;
			}
			else {
				console.log(`Unknown component ${props.decorator || props.is}`);
				return null;
			}
	}
};



// WEBPACK FOOTER //
// ./fe/web-levis/src/js/configureWebComponents.js